export const REGEX = {
  NUMBER_ONLY: /^\d+$/,
  SHORTCODE: /^\d+(\*\d+)*$/,
  MSISDN_WITH_PREFIX: /^\+234 \d{3} \d{3} \d{4}$/,
  MSISDN_WITHOUT_PREFIX: /^\d{3} \d{3} \d{4}$/,
  MSISDN_SIMPLE: /^\+\d{7,13}$/,
  AMOUNT: /^(?=0*[1-9])(?!0*1\.0+$)(?!0*1\.0+$|\d{4}\.)(\d+)((\d{1,3})*([, ]\d{3})*)(\.\d+)?$/,
  OTP: /^.{6}$/,
  CURRENCY_NUMBER: /(?=.*?\d)^\$?(([1-9]\d{0,2}(,\d{3})*)|\d+)?(\.\d{1,2})?$/,
  MERCHANT_CODE: /^\d{8}$/
};
